export interface BugDto {
  id: string;
  projectId: string;
  title: string;
  description?: string;
  severity: number;
  category: number;
  status: number;
  reporterId?: string;
  assigneeId?: string;
  relatedTaskId?: string;
  relatedIssueId?: string;
  stepsToReproduce?: string;
  environment?: string;
  createdAt?: string;
  comments?: BugCommentDto[];
}

export interface BugCommentDto {
  id: string;
  bugId: string;
  authorId?: string;
  content: string;
  createdAt: string;
}

export const BUG_SEVERITY_OPTIONS = [
  { value: 0, label: 'Trivial' },
  { value: 1, label: 'Minor' },
  { value: 2, label: 'Major' },
  { value: 3, label: 'Critical' }
];

export const BUG_CATEGORY_OPTIONS = [
  { value: 0, label: 'Functional' },
  { value: 1, label: 'Crash' },
  { value: 2, label: 'UI/UX' },
  { value: 3, label: 'Performance' }
];

export const BUG_STATUS_OPTIONS = [
  { value: 0, label: 'Open' },
  { value: 1, label: 'In Progress' },
  { value: 2, label: 'Resolved' },
  { value: 3, label: 'Verified' }
];
